import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { LandingCreateModel, LandingModel } from 'Pages/admin'
import { Id } from 'Src/types/aliases'

export type LandingsState = {
	list: ResponseCatalog<LandingModel>
	current: LandingModel | null
	requestParams: RequestParams
	isLoading: boolean
}

export const LandingstInitialState: LandingsState = {
	list: new ResponseCatalog<LandingModel>(),
	current: null,
	requestParams: new RequestParams(),
	isLoading: false,
}

export namespace LandingsNS {
	export type GetAll = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type GetOne = PayloadAction<Id>
	export type SetOne = PayloadAction<LandingModel>
	export type UpdateOne = PayloadAction<{
		id: Id
		data: LandingModel
		callback?: Callback
	}>
	export type CreateOne = PayloadAction<LandingCreateModel>
	export type SetAll = PayloadAction<ResponseCatalog<LandingModel>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type SetIsLoading = PayloadAction<boolean>
	export type DeleteOne = PayloadAction<Id>
}

export const LandingsSlice = createSlice({
	name: 'landings',
	initialState: LandingstInitialState,
	reducers: {
		getAll: (state, action: LandingsNS.GetAll) => {},
		setAll: (state, action: LandingsNS.SetAll) => {
			state.list = action.payload
		},
		setRequestParams: (state, action: LandingsNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.list = new ResponseCatalog<LandingModel>()
			state.requestParams = new RequestParams()
		},
		setIsLoading: (state, action: LandingsNS.SetIsLoading) => {
			state.isLoading = action.payload
		},
		getOne: (state, action: LandingsNS.GetOne) => {},
		setOne: (state, action: LandingsNS.SetOne) => {
			state.current = action.payload
		},
		updateOne: (state, action: LandingsNS.UpdateOne) => {},
		createOne: (state, action: LandingsNS.CreateOne) => {},
		deleteOne: (state, action: LandingsNS.DeleteOne) => {},
	},
})
